import { NavLink, Outlet } from 'react-router-dom';
import { Button } from '@tokenforge/design-system';
import { useAuth } from '../auth/useAuth';

export function SaaSShell() {
  const { user, licenseTier } = useAuth();

  return (
    <div className="min-h-dvh bg-background text-foreground">
      <header className="border-b border-border bg-background/95 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
          <div>
            <div className="text-xs uppercase tracking-[0.18em] text-foreground/45">
              TokenForge SaaS
            </div>
            <div className="mt-1 text-lg font-semibold">Workspace</div>
          </div>
          <div className="flex items-center gap-3 text-sm text-foreground/70">
            <span className="rounded-full bg-muted px-2.5 py-1 font-mono text-xs uppercase">
              {licenseTier}
            </span>
            <span>{user?.name ?? user?.email ?? 'Guest'}</span>
            <Button
              variant="secondary"
              size="sm"
              onClick={() => {
                window.location.href = '/saas-login';
              }}
            >
              切回登录入口
            </Button>
          </div>
        </div>
        <div className="mx-auto flex max-w-6xl items-center gap-2 px-6 pb-3">
          <NavLink
            to="/saas"
            end
            className={({ isActive }) =>
              [
                'rounded-full px-3 py-1.5 text-sm transition-colors',
                isActive
                  ? 'bg-foreground text-background'
                  : 'text-foreground/65 hover:bg-muted hover:text-foreground',
              ].join(' ')
            }
          >
            Workspace
          </NavLink>
          <a
            href="/saas-login"
            className="rounded-full px-3 py-1.5 text-sm text-foreground/65 transition-colors hover:bg-muted hover:text-foreground"
          >
            Session
          </a>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
}
